import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import OverlaySpinner from 'dibs-overlay-spinner';

import styles from './Notifications-style.scss';

const NotificationsSpinner = ({ size, isBlock, hideOverlay }) => {
    return (
        <div className={classnames(styles.spinnerContainer, {[styles.spinnerBlock]: isBlock})}>
            <OverlaySpinner
                additionalOverlayClasses={hideOverlay ? styles.hideOverlay : ''}
                additionalWrapperClasses={styles.spinnerWrapper}
                position={'isStatic'}
                size={size}
            />
        </div>
    );
};

NotificationsSpinner.propTypes = {
    hideOverlay: PropTypes.bool,
    size: PropTypes.string.isRequired,
    isBlock: PropTypes.bool
};

export default NotificationsSpinner;



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsSpinner.jsx